(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1MMdM", function(module, exports) {

$parcel$export(module.exports, "findBlocks", function () { return $14cfaddf7b657fa6$export$ee06a5357e65c7df; });
$parcel$export(module.exports, "isBlockEditor", function () { return $14cfaddf7b657fa6$export$22780c2770c6471f; });
$parcel$export(module.exports, "bootBlock", function () { return $14cfaddf7b657fa6$export$3ba659c19d85cb2f; });

var $2Xzd1 = parcelRequire("2Xzd1");
function $14cfaddf7b657fa6$var$findAll(root, selector) {
    var found = Array.from(root.querySelectorAll(selector));
    return root.matches && root.matches(selector) ? [
        root
    ].concat((0, $2Xzd1._)(found)) : found;
}
function $14cfaddf7b657fa6$export$ee06a5357e65c7df(root, selector) {
    return $14cfaddf7b657fa6$var$findAll(root, selector);
}
function $14cfaddf7b657fa6$export$22780c2770c6471f() {
    return Boolean(window.acf) && document.body.classList.contains('block-editor-page');
}
function $14cfaddf7b657fa6$export$3ba659c19d85cb2f(slug, init) {
    if ($14cfaddf7b657fa6$export$22780c2770c6471f()) {
        window.acf.addAction("render_block_preview/type=".concat(slug), function($block) {
            init($block.get(0), {
                isEditor: true
            });
        });
        return;
    }
    var run = function() {
        return init(document, {
            isEditor: false
        });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
}

});
parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});




var $1MMdM = parcelRequire("1MMdM");
var $4e80cf122b9d3f49$var$initializedBlocks = new WeakMap();
function $4e80cf122b9d3f49$var$initFaq(root) {
    (0, $1MMdM.findBlocks)(root, '.faq-block').forEach(function(block) {
        var activateTab = function activateTab(index) {
            tabs.forEach(function(tab, i) {
                var isActive = i === index;
                tab.classList.toggle('is-active', isActive);
                tab.setAttribute('aria-selected', String(isActive));
            });
            panels.forEach(function(panel, i) {
                var isActive = i === index;
                panel.classList.toggle('is-active', isActive);
                if (isActive) panel.removeAttribute('hidden');
                else panel.setAttribute('hidden', '');
            });
        };
        if ($4e80cf122b9d3f49$var$initializedBlocks.has(block)) return;
        var tabs = block.querySelectorAll('.faq__tab');
        var panels = block.querySelectorAll('.faq__panel');
        tabs.forEach(function(tab, index) {
            tab.addEventListener('click', function() {
                return activateTab(index);
            });
        });
        block.querySelectorAll('.faq__question').forEach(function(btn) {
            btn.addEventListener('click', function() {
                var isOpen = btn.getAttribute('aria-expanded') === 'true';
                var answerId = btn.getAttribute('aria-controls');
                var answer = block.ownerDocument.getElementById(answerId);
                if (!answer) return;
                btn.setAttribute('aria-expanded', String(!isOpen));
                btn.closest('.faq__item').classList.toggle('is-open', !isOpen);
                if (!isOpen) answer.removeAttribute('hidden');
                else answer.setAttribute('hidden', '');
            });
        });
        $4e80cf122b9d3f49$var$initializedBlocks.set(block, true);
    });
}
(0, $1MMdM.bootBlock)('faq', $4e80cf122b9d3f49$var$initFaq);

})();
//# sourceMappingURL=script.js.map
